/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const form6Slice = createSlice({
  name: 'form6',
  initialState: {
    serialNumber: '',
    engineNumber: '',
    plate: '',
    useOfTheVehicle: '8',
    vehicleType: '1',
    vehicleService: '1',
    emissionId: '',
    numberPolicy: '',
    quoteId: '',
  },
  reducers: {
    setFormData(state, { payload }) {
      state.serialNumber = payload.serialNumber;
      state.engineNumber = payload.engineNumber;
      state.plate = payload.plate;
      state.useOfTheVehicle = payload.useOfTheVehicle;
      state.vehicleType = payload.vehicleType;
      state.vehicleSeats = payload.vehicleSeats;
      state.capacity = payload.capacity;
      state.vehicleService = payload.vehicleService;
    },
    setPolicyEmissionData(state, { payload }) {
      state.emissionId = payload.emissionId;
      state.numberPolicy = payload.numberPolicy;
      state.quoteId = payload.quoteId;
    },
  },
});

export const form6Actions = form6Slice.actions;

export default form6Slice;
/* eslint-enable no-param-reassign */
